// extracted by mini-css-extract-plugin
export default {"PageSynthese":"PageSynthese_PageSynthese__yEJW-","BarreOutils":"PageSynthese_BarreOutils__eYQ1c","TitreNouveauPatient":"PageSynthese_TitreNouveauPatient__X1ejx"};